import Module from './Module';

class CategoryModule extends Module {
  constructor() {
    super('categories', '/api/v1/categories', true);
  }

  reducer(state = this.initialState, action) {
    const { GET_BY_ID, SAVE } = this.actionTypes;
    const { payload } = action;
    const data = payload && payload.data ? payload.data.data : null;

    switch (action.type) {
      case `${GET_BY_ID}_FULFILLED`:
        return { ...state, isLoading: false, edited: data, error: null };

      case `${SAVE}_FULFILLED`:
        return { ...state, isLoading: false, edited: data, error: null, successSave: true };

      default:
        return super.reducer(state, action);
    }
  }
}

const module = new CategoryModule();

export const {
  get, getById, save, remove, resetState, resetSuccessSave,
} = module;

export default module.reducer;



// WEBPACK FOOTER //
// ./src/modules/categories.js